import React from 'react';
import { ProductCard } from './ProductCard';
import { CheckIcon } from 'lucide-react';
export const AccountSelection = ({
  selectedProducts,
  onProductSelect,
  onContinue,
  onSeeAllProducts
}) => {
  return <div className="flex flex-col p-6 flex-grow" data-id="element-22">
      <h1 className="text-2xl font-bold mb-2" data-id="element-23">
        Welcome to our secure account opening solution for community financial
        institutions.
      </h1>
      <p className="text-gray-700 mb-6" data-id="element-24">
        We've modeled our product selection process off of the best-in-class
        retail commerce experiences. Select your product to continue.
      </p>
      <h2 className="text-lg font-bold mb-4" data-id="element-25">Recommended Products</h2>
      <ProductCard title="Pinnacle Checking" description="No minimum balance. No monthly fees." learnMoreLink="#" isSelected={selectedProducts.checking} onClick={() => onProductSelect('checking')} data-id="element-26" />
      <ProductCard title="Savings Account" description="$5.00 minimum deposit required" subDescription="Open your savings account and you become eligible for our high-yield savings options." learnMoreLink="#" isSelected={selectedProducts.savings} onClick={() => onProductSelect('savings')} data-id="element-27" />
      <div className="mt-6" data-id="element-28">
        <h2 className="text-lg font-bold mb-4" data-id="element-29">Recommended Features</h2>
        <div className="border border-gray-200 rounded-lg p-4 mb-2" data-id="element-30">
          <div className="flex items-center justify-between" data-id="element-31">
            <span className="font-medium" data-id="element-32">Daily Overdraft Protection</span>
            <CheckIcon className="text-white bg-gray-200 rounded-full p-1" size={24} data-id="element-33" />
          </div>
        </div>
      </div>
      <div className="mt-auto" data-id="element-34">
        <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium mb-4" onClick={onContinue} data-id="element-35">
          Continue
        </button>
        <button className="w-full text-[#5c5cf5] font-medium" onClick={onSeeAllProducts} data-id="element-36">
          See all products
        </button>
      </div>
    </div>;
};